// removed by extract-text-webpack-plugin
module.exports = {"base":"_1nrSa","joel":"exhCZ","letter":"_3Jb12","small":"_7O5tg","smallest":"_1CJdP","medium":"_1LnCK","large":"_3QUSg","mega":"_3KimW","massive":"_15UWq","lightBlue":"_2K8SV","blue":"_3yEyR","darkBlue":"_22Lnv","lightGreen":"_3h55N","green":"_35Dde","darkGreen":"_3MsJQ","grey":"_32q5A","group":"_27Fpz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.scss
// module id = 2612
// module chunks = 0